var tf = null;
export function setBackend(tfInput) {
    tf = tfInput;
}
export function getBackend() {
    if (tf === null) {
        throw Error("\n============================\nHowdy \uD83D\uDC4B\uD83D\uDC4B. Looks like you are running scikit but you haven't set a Tensorflow backend. \nTo do so, simply import (or require) your tensorflow library, and call setBackend like so,\n\nimport * as tf from '@tensorflow/tfjs'\nimport * as sk from 'scikitjs'\nsk.setBackend(tf)\n\nThat will let scikit know you wish to use a tensorflow library to perform your calculations.\n============================\n    ");
    }
    return tf;
}
